/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Task added or removed between the pinned module version and the upgrade target.
 */
export interface ModuleUpgradeTaskChange {
  taskId: string;
  title: string;
  hasProgress?: boolean;
}
